module.exports = __webpack_public_path__ + "static/img/banner.a9918d7e.png";